import { client } from "./api";

import {
  IAddress,
  ISuperficialAddress,
  ISuperficialAddressProps,
} from "interfaces/Address";
import {
  IGetFilterProps,
  IFilterData,
  IGetUniqueData,
} from "interfaces/FilterProps";
interface localeProps {
  locale: IAddress;
  name: string;
}

export async function getByIdAddressService(id: string) {
  const api = client();
  const response = await api.get<IGetUniqueData<any>>(
    `superficial/address/one`,
    {
      params: {
        where: { id },
      },
    }
  );
  return response.data;
}

export async function createAddressService({ locale, name }: localeProps) {
  const api = client();
  const response = await api.post("addresses/store", {
    ...locale,
    name,
  });
  return response.data;
}

export async function getAddressService(): Promise<IFilterData<IAddress>> {
  const api = client();
  const response = await api.get<IFilterData<IAddress>>("addresses/store");
  return response.data;
}

interface IParams {
  subclientId: string;
  address: ISuperficialAddressProps;
  CoordX: number;
  CoordY: number;
  establishmentName: string;
}

export async function createSubclientSuperficialAddress({
  subclientId,
  address,
  CoordX,
  CoordY,
  establishmentName,
}: IParams): Promise<any> {
  const api = client();
  const response = await api.post("superficial/address", {
    superficialClient: { id: subclientId },
    ...address,
    CoordX,
    CoordY,
    name: establishmentName,
  });
  return response.data;
}

export async function updateSuperficialAddress(
  data: Omit<
    ISuperficialAddress,
    "createdAt" | "updatedAt" | "active" | "occurrence"
  >
) {
  const api = client();
  const response = await api.patch("superficial/address", {
    ...data,
  });

  return response.data;
}

export async function deleteSuperficialAddress(id: string) {
  const api = client();
  const response = await api.delete(`superficial/address/${id}`);
  return response.data;
}
